export default [
  { id: "00001", title: "BAC" },
  { id: "00002", title: "BANCO AGROMERCANTIL DE GUATEMALA, S.A." },
  { id: "00003", title: "BANCO AZTECA DE GUATEMALA" },
  { id: "00005", title: "BANCO DE CREDITO, S.A." },
  { id: "00006", title: "BANCO DE GUATEMALA" },
  { id: "00008", title: "BANCO DE LOS TRABAJADORES" },
  { id: "00009", title: "BANCO FICOHSA GUATEMALA" },
  { id: "00010", title: "BANCO G&T CONTINENTAL" },
  { id: "00011", title: "BANCO INDUSTRIAL, S.A." },
  { id: "00012", title: "BANCO INMOBILIARIO, S.A." },
  { id: "00013", title: "BANCO INTERNACIONAL, S.A." },
  { id: "00015", title: "BANCO PROMERICA, S.A." },
  { id: "00017", title: "BANRURAL S.A." },
  { id: "00018", title: "CITIBANK N.A. SUCURSAL GUATEMALA" },
  { id: "00019", title: "EL CREDITO HIPOTECARIO NACIONAL DE GUATEMALA" },
  {
    id: "00022",
    title: "PRIMER BANCO DE AHORRO Y PRSTAMO PARA LA VIVIENDA FA",
  },
  { id: "00023", title: "VIVIBANCO, SOCIEDAD ANONIMA" },
  { id: "09999", title: "OTROS" },
];
